var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: { id: _vm.id, "hide-footer": "", title: "Confirmation" },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.message))]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "flex f-center" },
                [
                  _c(
                    "b-link",
                    {
                      staticClass: "blinki-close-btn",
                      on: {
                        click: function ($event) {
                          return _vm.resetModal()
                        },
                      },
                    },
                    [_vm._v("Annuler")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-2 blinki-submit-btn",
                      attrs: { type: "button", variant: "primary" },
                      on: { click: _vm.handleOk },
                    },
                    [_vm._v("D'accord")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }